var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Circles"},[_c('canvas'),(_vm.initialized)?_vm._l((_vm.channel),function(color,i){return _c('Base',{key:i,ref:'base_'+ i,refInFor:true,attrs:{"channel":color,"indice":i}})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }